import { render } from "./Main.vue?vue&type=template&id=41033d07"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=41033d07&lang=scss"

import exportComponent from "C:\\development\\AdmicomWeb\\AdmicomWeb.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__